import { render, staticRenderFns } from "./AffinityAttribute.vue?vue&type=template&id=5c8862cd"
import script from "./AffinityAttribute.vue?vue&type=script&lang=js"
export * from "./AffinityAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports